import { render, staticRenderFns } from "./TablaPerfilxUsuario.vue?vue&type=template&id=260af4f3&scoped=true&"
import script from "./TablaPerfilxUsuario.vue?vue&type=script&lang=js&"
export * from "./TablaPerfilxUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TablaPerfilxUsuario.vue?vue&type=style&index=0&id=260af4f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260af4f3",
  null
  
)

export default component.exports